import React from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getEntries, getSearch, getFilters, getSettings } from '../../common/services/selectors';
import ListingCard from '../components/_3ColListingCard_tesCoursesLister';
import Pager from '../../common/components/_Pager';
import TesCoursesFilter from './tesCoursesFilter';

function TesCourses({ entries, search, filters, settings }) { 
    const { items = [] } = entries || {};
	return (
        <div> 
            <div className="row column">
                <TesCoursesFilter search={search} settings={settings} filters={filters} />
            </div>
            <div className="row">
                <div className="large-12 column">
                    {entries.totalCount === 0 && <p>Nothing Found</p>}
                    {entries.totalCount > 0 && 
                        items.map((entry, index) => <ListingCard key={entry.sys.id} entry={entry} index={index} settings={settings} />) }
                    {/* {entries.totalCount > 0 && 
                        items.map((entry, index) => <TesCoursesItem key={entry.sys.id} entry={entry} index={index} />) } */}
                </div>
            </div>
            {entries.totalCount > 10 && <Pager entries={entries} search={search} settings={settings} />}
        </div>
	);
}


TesCourses.propTypes = {
    entries: PropTypes.object,
};

const mapStateToProps = state => ({ entries: getEntries(state), search: getSearch(state), filters: getFilters(state), settings: getSettings(state) });

export default connect(mapStateToProps)(TesCourses);